
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  font-family:var(--ff-body);
  --footer-bg-color:var(--brand-dark-blue-900);
  --separator-color:var(--brand-blue-accent);
}

footer{
  width:100%;
  background-color:var(--footer-bg-color);
}

.logo{
  max-width:300px;
  width:100%;
  flex-shrink:0;
}

.logo ::slotted(*){
    display:inline-block;
    max-width:300px;
    width:100%;
  }

.footer-container{
  display:flex;
  flex-direction:column;
}

.footer-top,
.footer-bottom{
  display:flex;
  justify-content:center;
  align-items:center;
  gap:var(--spacing-4);
  width:100%;
}

.footer-top{
  padding-block-end:var(--spacing-4);
  flex-direction:column;
}

@media (min-width: 1024px){

.footer-top{
    flex-direction:row;
    padding-block-end:var(--spacing-10)
}
  }

.footer-bottom{
  gap:var(--spacing-8);
  padding-top:var(--spacing-4);
  justify-content:space-between;
  flex-direction:column;
}

@media (min-width: 1024px){

.footer-bottom{
    flex-direction:row;
    flex-wrap:wrap;
    gap:var(--spacing-4);
    padding-top:var(--spacing-8)
}
  }

.contact-info{
  color:var(--brand-white);
  display:flex;
  justify-content:center;
  align-items:center;
  flex-direction:column;
  gap:var(--spacing-4);
}

@media (min-width: 1024px){

.contact-info{
    flex-direction:row
}
  }

.site-links-container{
  display:flex;
  flex:1;
  justify-content:center;
  align-items:center;
  flex-direction:column;
  gap:var(--spacing-5);
}

@media (min-width: 1024px){

.site-links-container{
    flex-direction:row;
    gap:0
}
  }

.site-links{
  display:flex;
  flex:1;
}

.right-links{
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  padding:0 var(--spacing-4);
  gap:var(--spacing-4);
}

.social-links{
  display:flex;
  flex:1;
  justify-content:center;
  align-items:center;
  gap:var(--spacing-4);
  margin-top:var(--spacing-4);
}

.separator{
  width:100%;
  height:4px;
  background-color:var(--separator-color);
}

.contact-separator{
  display:none;
  width:1px;
  height:var(--spacing-4);
  background-color:var(--brand-white);
}

@media (min-width: 1024px){

.contact-separator{
    display:block
}
  }

ul{
  display:flex;
  flex-direction:column;
  color:var(--brand-white);
  list-style:none;
  margin:0;
  padding:0;
  gap:var(--spacing-4);
  align-items:center;
}

@media (min-width: 1024px){

ul{
    flex-direction:row;
    flex-wrap:wrap;
    gap:var(--spacing-6) var(--spacing-4);
    justify-content:flex-start
}
  }

@media (min-width: 1280px){

ul{
    flex-wrap:nowrap;
    justify-content:space-between;
    gap:normal
}
  }

div[slot='footer-links'] ul{
  display:grid;
  grid-template-columns:repeat(2, 1fr);
  grid-template-rows:repeat(2, 1fr);
  text-decoration:underline;
}

@media (min-width: 1024px){

div[slot='footer-links'] ul{
    display:flex;
    gap:var(--spacing-6)
}
  }

div[slot='footer-links'] ul a{
    color:var(--brand-white);
  }

div[slot='footer-links'] ul a:visited{
      color:var(--brand-white);
    }

div[slot='footer-links'] ul a:hover,
    div[slot='footer-links'] ul a:focus-visible{
      opacity:0.8;
    }

slot[name='address']::slotted(*){
  text-align:center;
}

div[slot='logo'] img{
    max-width:300px;
    width:100%;
  }

div[slot='site-links'] ul{
    flex:1;
    padding-inline:var(--spacing-14);
    font-weight:var(--fw-bold);
    font-size:var(--fs-lg);
    margin-top:var(--spacing-2);
    font-family:var(--ff-display);
  }

@media (min-width: 1024px){

div[slot='site-links'] ul{
      padding-inline:var(--spacing-6);
      gap:var(--spacing-4) 0
  }
    }

@media (min-width: 1024px){

div[slot='site-links'] ul li{
        flex-basis:50%
    }
      }

@media (min-width: 1280px){

div[slot='site-links'] ul li{
        flex-basis:auto
    }
      }

div[slot='site-links'] ul a{
      color:var(--brand-white);
    }

div[slot='site-links'] ul a:visited{
        color:var(--brand-white);
      }

div[slot='site-links'] ul a:hover,
      div[slot='site-links'] ul a:focus-visible{
        opacity:0.8;
        text-decoration:underline;
      }

@media (min-width: 1024px){

div[slot='site-links']{
    display:flex;
    flex:1
}
  }

div[slot='social-links'] ul{
    gap:var(--spacing-6);
    flex-direction:row;
  }

div[slot='social-links'] ul a{
      transition:all 0.3s ease;
    }

div[slot='social-links'] ul a:hover{
        opacity:0.8;
      }
`;